import BaseballResultsProcessor from "../entities/BaseballResultsProcessor.js";
import ResultsFormatterBase from "./ResultsFormatterBase.js";
import sessionResultsFormatter from "./SessionResultsFormatter.js";

const IncompatibleSessionResultsFormatter = function(compatibilityResultsFormatter, results, strikeZoneModel){
    if (!(compatibilityResultsFormatter instanceof ResultsFormatterBase)) {
        throw new TypeError('compatibilityResultsFormatter must be an instance inheriting from ResultsFormatterBase class');
    }

    const compatibleResults = BaseballResultsProcessor.applyFormatting(results, compatibilityResultsFormatter);
    return sessionResultsFormatter(compatibleResults, strikeZoneModel);
};

export default IncompatibleSessionResultsFormatter;